import { render, staticRenderFns } from "./access_parking_records.vue?vue&type=template&id=5772b20c&scoped=true"
import script from "./access_parking_records.vue?vue&type=script&lang=js"
export * from "./access_parking_records.vue?vue&type=script&lang=js"
import style0 from "./access_parking_records.vue?vue&type=style&index=0&id=5772b20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5772b20c",
  null
  
)

export default component.exports